export default __webpack_public_path__ + "static/Glassdoor-790e12ecc38fee84db5d636a57395216.png";